import type { WizardAnswers } from '@/context/WizardSessionContext';

export function hasEntrepreneurProfile(answers: WizardAnswers): boolean {
  return Boolean(answers.contact_name?.trim() && answers.venture_type?.trim());
}
